module.exports = __webpack_public_path__ + "static/media/ARROZV_MENU-normal.30c96b73.png";